import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS, getShouldHideSegments } from "./utils";

export const UniqueVisitors = {
    id: "SegmentsUniqueVisitors",
    properties: {
        order: "3",
        dropdownOrder: 3,
        hasWebSource: true,
        isHidden: getShouldHideSegments,
        component: "CustomSegments",
        mobileWebComponent: "MobileWebSearch",
        viewPermissions: {
            trafficSources: ["Desktop", "Total"],
        },
        title: "folderanalysis.tabs.unique",
        group: "WebsiteAudienceOverview",
        family: SEGMENTS_FAMILY_NAME,
        dashboard: "true",
        state: "digitalsuite_segments-analysis-traffic",
        apiController: "CustomSegments",
        webSource: "Desktop",
        availabilityComponent: "CustomSegments",
        totalComponent: "TotalWebCustomSegmentsAnalysis",
        timeGranularity: "Monthly",
        noCompare: true,
        periodOverPeriodSupport: true,
        defaultDuration: DEFAULT_DURATION_FOR_SEGMENTS,
    },
    widgets: {
        single: {
            defaultType: "SegmentsUniqueVisitorsGraph",
            SegmentsUniqueVisitorsGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                    periodOverPeriodSupport: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double?",
                    format: "minVisitsAbbr",
                    formatParameter: 3,
                    name: "CurrentInstalls",
                    reversed: "False",
                },
            },
        },
        compare: {
            defaultType: "SegmentsUniqueVisitorsGraph",
            SegmentsUniqueVisitorsGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double",
                    format: "percentagesign",
                    formatParameter: 0,
                    name: "Retention",
                    reversed: "False",
                    yAxisMax: 1,
                },
            },
        },
        ComparedBar: {
            properties: {
                hasWebSource: true,
                width: "4",
                periodOverPeriodSupport: true,
                options: {
                    showLegend: false,
                    mobileWebAlgoChangeDate: true,
                    dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                },
            },
            filters: {
                ShouldGetVerifiedData: [
                    {
                        value: "true",
                        title: "Yes",
                    },
                    {
                        value: "false",
                        title: "No",
                    },
                ],
            },
            y_axis: {
                title: "Unique Visitors",
                type: "None",
                format: "time",
                name: "UniqueUsers",
                reversed: "False",
            },
        },
        ComparedLine: {
            properties: {
                hideMarkersOnDaily: true,
                periodOverPeriodSupport: true,
                options: {
                    showLegend: false,
                    mobileWebAlgoChangeDate: true,
                    dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                },
            },
            x_axis: {
                title: "Date",
                type: "date",
                format: "None",
                name: "Date",
                reversed: "False",
            },
            y_axis: {
                title: "Unique Visitors",
                type: "long",
                format: "None",
                name: "UniqueUsers",
                reversed: "False",
            },
            filters: {
                ShouldGetVerifiedData: [
                    {
                        value: "true",
                        title: "Yes",
                    },
                    {
                        value: "false",
                        title: "No",
                    },
                ],
            },
        },
    },
};
